<template>
	<div class="comment-editor no-select">
		<div class="header-section">
			<span v-show="insertingRating">{{name}}, Write Your Review</span>
			<span v-show="updatingRating">{{name}}, Edit Your Review</span>
			<span v-show="insertingRegular">{{name}}, Write Your Comment</span>
			<span v-show="updatingRegular">{{name}}, Edit Your Comment</span>
			<img class="avatar ms-3" :src="avatarUrl" />
		</div>
		<div class="rating-section mt-2" v-show="isRating">
			<span>Pick Rating</span>
			<div class="stars" :class="clsStars()">
				<img v-for="(starImgUrl, i) in getStarImageUrls(dRating)" :src="starImgUrl" @click="setRating(i + 1)" width="40" height="40" />
			</div>
		</div>
		<div class="title-section mt-2" v-show="isRating">
			<span>Add Title</span>
			<limited-input
				:placeholder="titlePlaceHolder"
				:max-chars="maxCharsTitle"
				:max-chars-red.number="pct90(maxCharsTitle)"
				:text-area="Boolean(false)"
				:disabled="disableInputs"
				v-model="dTitle">
			</limited-input>
		</div>
		<div class="review-section mt-2">
			<span v-show="isRating">Add Review</span>
			<span v-show="isRegular">Add Comment</span>
			<limited-input
				:placeholder="bodyPlaceHolder"
				:max-chars="maxCharsBody"
				:max-chars-red.number="pct90(maxCharsBody)"
				:text-area="Boolean(1)"
				:disabled="disableInputs"
				v-model="dBody">
			</limited-input>
		</div>
		<div class="control-section mt-2">
			<span class="btn-cancel" :class="clsCancelButton()" @click="cancelEditor">Cancel</span>
			<button type="button" class="btn-button btn-update ms-3" :class="clsSubmitButton()" @click="updateComment" :disabled="disableSubmitButton">
				<span v-show="insertingRating && !requestsActive">Publish Review</span>
				<span v-show="updatingRating && !requestsActive">Update Review</span>
				<span v-show="insertingRegular && !requestsActive">Publish Comment</span>
				<span v-show="updatingRegular && !requestsActive">Update Comment</span>
				<img v-show="requestsActive" src="/img/loaders/spinner-1s-200px-white.svg" />
			</button>
		</div>
	</div>
</template>




<script>
	import limitedInput from './LimitedInput.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			limitedInput
		},
		data: () => ({
			dRating : 0,
			dTitle : '',
			dBody : ''
		}),
		props: {
			name            : { type: String,  required: false, default: () => '' },
			avatarUrl       : { type: String,  required: false, default: () => '' },
			index           : { type: Number,  required: false, default: () => 0 },
			id              : { type: Number,  required: false, default: () => 0 },
			rating          : { type: Number,  required: false, default: () => 0 },
			title           : { type: String,  required: false, default: () => '' },
			body            : { type: String,  required: false, default: () => '' },
			parentCommentId : { type: Number,  required: false, default: () => null },
			topCommentId    : { type: Number,  required: false, default: () => null },
			packageId       : { type: Number,  required: false, default: () => null },
			isRating        : { type: Boolean, required: false, default: () => true },
			editExisting    : { type: Boolean, required: false, default: () => true },
			maxCharsTitle   : { type: Number,  required: false, default: () => 0 },
			maxCharsBody    : { type: Number,  required: false, default: () => 0 }
		},
		created() {
			this.dRating = this.rating;
			this.dTitle = this.title;
			this.dBody = this.body;
		},
		methods: {
			getStarImageUrls(rating) {
				return common.getStarImageUrls(rating);
			},
			setRating(rating) {
				if (!this.requestsActive) {
					this.dRating = rating;
				}
			},
			updateComment() {
				var req = this.mixinAxios().post(this.requestString, this.commentEntity)
					.then((res) => {
						var commentData = {
							index : this.index,
							comment : res.data
						}

						var eventName = (this.publishNew) ? 'comment-added' : 'comment-edited';
						this.$emit(eventName, commentData);
					});
			},
			cancelEditor() {
				if (!this.requestsActive) {
					this.$emit('editor-cancelled', this.id);
				}
			},
			pct90(val) {
				return ((val * 0.9).toFixedNumber(0));
			},
			clsStars() {
				return {
					'cursor-default' : this.requestsActive
				};
			},
			clsCancelButton() {
				return {
					'cursor-default' : this.requestsActive
				};
			},
			clsSubmitButton() {
				return {
					'processing' : this.requestsActive
				};
			}
		},
		computed: {
			isRegular() {
				return !this.isRating;
			},
			publishNew() {
				return !this.editExisting;
			},
			insertingRating() {
				return (this.isRating && this.publishNew);
			},
			updatingRating() {
				return (this.isRating && this.editExisting);
			},
			insertingRegular() {
				return (this.isRegular && this.publishNew);
			},
			updatingRegular() {
				return (this.isRegular && this.editExisting);
			},
			titlePlaceHolder() {
				return (this.isRating)
					? "What's most important about this bundle?"
					: "Give your comment a summary."; // isRegular
			},
			bodyPlaceHolder() {
				return (this.isRating)
					? "Was this bundle to your liking? What did you love most about it?"
					: "Let the world know what's on your mind."; // isRegular
			},
			ratingPicked() {
				return [1, 2, 3, 4, 5].includes(this.dRating);
			},
			noRatingPicked() {
				return !this.ratingPicked;
			},
			disableSubmitButton() {
				return (this.requestsActive || this.noRatingPicked);
			},
			disableInputs() {
				return this.requestsActive;
			},
			requestString() {
				var action = (this.insertingRating)
					? 'AddRating'
					: (this.updatingRating)
					? 'EditRating'
					: (this.insertingRegular)
					? 'AddRegular'
					: (this.editingRegular)
					? 'EditRegular'
					: 'Unknown';

				return `/api/user/${action}/`;
			},
			commentEntity() {
				return {
					id              : this.id,
					rating          : this.dRating,
					title           : this.dTitle,
					body            : this.dBody,
					name            : this.name,
					avatarUrl       : this.avatarUrl,
					parentCommentID : this.parentCommentId,
					topCommentID    : this.topCommentId,
					packageID       : this.packageId
				};
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	.comment-editor {
		border:1px solid #e2e9ee;
		border-radius:10px;
		padding:10px 10px;
	}

	.header-section {
		display:flex;
		justify-content:space-between;
		align-items:center;
	}

	.header-section span {
		display:block;
		font-size:1.35em;
		font-weight:bold;
	}

	.header-section img.avatar {
		width:50px;
		height:50px;
	}

	.rating-section span, .title-section span, .review-section span {
		display:block;
		font-size:1.25em;
	}

	:deep(.review-section textarea) {
		height:100px;
	}

	:deep(input), :deep(textarea) {
		border:1px solid #888c8c;
		border-radius:5px;
		width:100%;
		outline-color:#1299fd;
	}

	:deep(input:focus), :deep(textarea:focus) {
		background:#f7feff;
	}

	.stars {
		display:flex;
		margin-left:-4px; /* make up for whitespace next to svg stars */
	}

	.stars img {
		width:40px;
		height:40px;
		cursor:pointer;
	}

	.stars.cursor-default img {
		cursor:default;
	}

	.btn-button {
		min-width:100px;
		border-radius: 10px;
		padding: 5px 12px;
		background: #1299fd;
		border: 0px solid gray;
		color: white;
		font-weight:bold;
	}

	.btn-update {
		background: #1299fd;
	}

	.btn-button:hover {
		background: #0188ec;
	}

	.btn-button:disabled {
		background: #eeeeee;
		color:#808080;
	}

	.btn-button.processing:disabled {
		background: #1299fd;
		color:#808080;
	}

	.btn-button img {
		width:20px;
		height:20px;
	}

	.btn-cancel {
		text-decoration: underline;
		font-weight: bold;
		cursor: pointer;
		color: gray;
	}

	.control-section {
		display:flex;
		justify-content:end;
		align-items:center;
	}

	.cursor-default {
		cursor:default;
	}

	@media screen and (min-width:500px) {
		.comment-editor {
			padding:15px 15px;
		}
	}

</style>